<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">{{ adminText('organizationAll.export_report_95a441cf', 'Export Report') }}</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        {{ adminText('organizationAll.you_can_export_your_report_choose_the_appropr_45b26b89', 'You can export your Report. Choose the appropriate format of the file depending on the purpose.') }}
      </div>
      <div class="export-container">
        <div class="export-item" @click="$emit('handleExcelExport')">
          <img
            src="/assets/file-table.svg"
            :alt="adminText('organizationAll.excel_file_icon_28140a80', 'Excel file icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
          <span class="export-item-text">{{ adminText('organizationAll.excel_a08e1111', 'Excel') }}</span>
        </div>
        <div class="export-item" @click="$emit('handleCsvExport')">
          <img
            src="/assets/file-csv.svg"
            :alt="adminText('organizationAll.csv_file_icon_1f8f2415', 'CSV file icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
          <span class="export-item-text">{{ adminText('organizationAll.csv_32811883', 'CSV') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

export default {
  mixins: [OrganizationLocalization],
  name: 'reports-export-modal',
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  color: #979797;
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.export-container {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  :hover {
    cursor: pointer;
  }
}
.export-item {
  display: flex;
  padding: 2rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  flex: 1 0 0;
  border-radius: 0.75rem;
  border: 2px solid #d9d9d9;
  background: #f5f5f5;
}
.export-item-text {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}
</style>
